// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qy-0";